import { Header } from "@/components/site/Header";
import { GoogleReviews } from "@/components/site/GoogleReviews";
import { Footer } from "@/components/site/Footer";
import { StickyCTA } from "@/components/site/StickyCTA";
import { QuoteModal } from "@/components/site/QuoteModal";

export default function Reviews() {
  return (
    <div className="App bg-background">
      <Header solid />
      <main className="pt-20">
        <GoogleReviews />
      </main>
      <Footer />
      <StickyCTA />
      <QuoteModal />
    </div>
  );
}
